import MaintenancePage from "../MaintenancePage";
import organisationResource from "../../resources/organisationResource";

export default function Organisation() {
    return <MaintenancePage resource={organisationResource} />;
}
